<template>
    <v-app :style=cssClass()>
        <page-controller></page-controller>
    </v-app>
</template>

<script>

import PageController from "@/pages/PageController"
import { Utils } from "@/Utils";

export default
{
    components:
    {
        PageController
    },
    mixins: [Utils],
    methods:
    {
        cssClass()
        {
            if (this.isAuthenticated())
                return {background: "#474749"};
            else
            {
                var image = require('@/assets/Background.png');
                return {                    
                    background: 'linear-gradient(114deg, rgba(34,89,100,1) 0%, rgba(118,198,163,1) 60%)',
                    backgroundImage: "url('"+image+"')"                    
                }            
            }
        }
    }

};



</script>

<style lang="css">

@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css");

span.v-btn__content{
    text-transform: none !important;
}

</style>